import React, { useId } from 'react';
import {
  FormControl,
  FormLabel,
  Select,
  SelectProps
} from '@mui/material';

export type AppSelectFieldProps<Value = unknown> = {
  label: React.ReactNode;
} & SelectProps<Value>;

function AppSelectField<Value = unknown>({
  label,
  fullWidth = true,
  labelId: labelIdProp,
  id: idProp,
  children,
  ...selectProps
}: AppSelectFieldProps<Value>) {
  const uid = useId();
  const labelId = labelIdProp ?? `app-select-${uid}`;
  return (
    <FormControl fullWidth={fullWidth}>
      <FormLabel id={labelId}>{label}</FormLabel>
      <Select<Value>
        {...selectProps}
        id={idProp}
        labelId={labelId}
        fullWidth={fullWidth}
      >
        {children}
      </Select>
    </FormControl>
  );
}

export default AppSelectField;
